const AuthLayout = ({children}) => {
    return (
        <div className="container-fluid bg-black" style={divStyling}>
            <div className="d-flex flex-column" style={{height: '100vh', maxHeight: '100vh'}}>
                <div className="my-auto">
                    {children}
                </div>
            </div>
        </div>
    )
}

const divStyling = {
    backgroundColor: 'black',
    color: 'white',
}

export default AuthLayout;
